/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelMenuOrders
 */
export interface FuelMenuOrders {
    /**
     * 
     * @type {string}
     * @memberof FuelMenuOrders
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof FuelMenuOrders
     */
    grandTotalFiat: number;
    /**
     * 
     * @type {string}
     * @memberof FuelMenuOrders
     */
    createdAt: string;
    /**
     * Total Fuel used across all payment methods (off-chain + on-chain).
     * @type {number}
     * @memberof FuelMenuOrders
     */
    fuelTotalUsed: number;
    /**
     * Off-chain Fuel used.
     * @type {number}
     * @memberof FuelMenuOrders
     */
    fuelUsed: number;
    /**
     * On-chain FuelX used.
     * @type {number}
     * @memberof FuelMenuOrders
     */
    onChainUsed?: number;
    /**
     * 
     * @type {string}
     * @memberof FuelMenuOrders
     */
    etherscanLink?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelMenuOrders
     */
    walletType?: string;
    /**
     * 
     * @type {number}
     * @memberof FuelMenuOrders
     */
    fuelTotalFiat: number;
}

/**
 * Check if a given object implements the FuelMenuOrders interface.
 */
export function instanceOfFuelMenuOrders(value: object): value is FuelMenuOrders {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('grandTotalFiat' in value) || value['grandTotalFiat'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('fuelTotalUsed' in value) || value['fuelTotalUsed'] === undefined) return false;
    if (!('fuelUsed' in value) || value['fuelUsed'] === undefined) return false;
    if (!('fuelTotalFiat' in value) || value['fuelTotalFiat'] === undefined) return false;
    return true;
}

export function FuelMenuOrdersFromJSON(json: any): FuelMenuOrders {
    return FuelMenuOrdersFromJSONTyped(json, false);
}

export function FuelMenuOrdersFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelMenuOrders {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'grandTotalFiat': json['grandTotalFiat'],
        'createdAt': json['createdAt'],
        'fuelTotalUsed': json['fuelTotalUsed'],
        'fuelUsed': json['fuelUsed'],
        'onChainUsed': json['onChainUsed'] == null ? undefined : json['onChainUsed'],
        'etherscanLink': json['etherscanLink'] == null ? undefined : json['etherscanLink'],
        'walletType': json['walletType'] == null ? undefined : json['walletType'],
        'fuelTotalFiat': json['fuelTotalFiat'],
    };
}

export function FuelMenuOrdersToJSON(json: any): FuelMenuOrders {
    return FuelMenuOrdersToJSONTyped(json, false);
}

export function FuelMenuOrdersToJSONTyped(value?: FuelMenuOrders | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'grandTotalFiat': value['grandTotalFiat'],
        'createdAt': value['createdAt'],
        'fuelTotalUsed': value['fuelTotalUsed'],
        'fuelUsed': value['fuelUsed'],
        'onChainUsed': value['onChainUsed'],
        'etherscanLink': value['etherscanLink'],
        'walletType': value['walletType'],
        'fuelTotalFiat': value['fuelTotalFiat'],
    };
}

